import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const Room = ({
  id,
  title,
  subtitle,
  className,
  descriptionClassName,
  timelineIconClassName,
}) => {
  const elemId = title.replace(/ /g, '_').toLowerCase();

  return (
    <div id={id || elemId} className={`${className} ${styles.timelineRoom}`}>
      <div
        className={`${timelineIconClassName} ${styles.timelineRoomIcon}`}
        title={`${title} - ${subtitle}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 63">
          <g>
            <path
              id="Layer0_27_MEMBER_0_MEMBER_0_1_STROKES"
              data-name="Layer0 27 MEMBER 0 MEMBER 0 1 STROKES"
              d="M44.14,39.86a4.09,4.09,0,0,0,3-1.31,4.29,4.29,0,0,0,1.31-3V29.59a4.47,4.47,0,0,0-4.48-4.49,4.42,4.42,0,0,0-3.17,1.31,4.31,4.31,0,0,0-1.31,3.18v4.13m-15.92,0V29.59a4.47,4.47,0,0,0-4.48-4.49,4.47,4.47,0,0,0-4.48,4.49v5.94a4.29,4.29,0,0,0,1.31,3,4.23,4.23,0,0,0,3,1.31m.2,0H19m.2,0h.25m24.43,0h-.25m.35,0H44m-20.5-6.14H39.46M19,39.86h-.1m.2,0h.1m.25,0H43.59m.35,0h-.1m.2,0h.1"
              style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
            />
            <path
              id="Layer0_27_MEMBER_0_MEMBER_1_MEMBER_0_1_STROKES"
              data-name="Layer0 27 MEMBER 0 MEMBER 1 MEMBER 0 1 STROKES"
              d="M39.23,14.59a4.37,4.37,0,0,1,3,1.31,4.29,4.29,0,0,1,1.3,3.16v5.49m-4.57-10h-.26m-14.62,0h.26m-.36,0h-.1m-.09,0a4.37,4.37,0,0,0-3,1.31,4.29,4.29,0,0,0-1.3,3.16v5.49M39,14.59h.1m-.46,0H24.32m-.36,0h.1m-.2,0h-.09m15.37,0h.09m-.19,0h-.1"
              style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
            />
            <path
              id="Layer0_27_MEMBER_1_MEMBER_0_1_STROKES"
              data-name="Layer0 27 MEMBER 1 MEMBER 0 1 STROKES"
              d="M61.5,31.52a28.88,28.88,0,0,1-8.78,21.2,28.88,28.88,0,0,1-21.2,8.78,28.94,28.94,0,0,1-21.24-8.78A28.88,28.88,0,0,1,1.5,31.52a28.94,28.94,0,0,1,8.78-21.24A28.94,28.94,0,0,1,31.52,1.5a28.88,28.88,0,0,1,21.2,8.78A28.94,28.94,0,0,1,61.5,31.52Z"
              style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2.5px' }}
            />
            <g>
              <path
                id="Layer0_27_MEMBER_0_MEMBER_2_1_STROKES"
                data-name="Layer0 27 MEMBER 0 MEMBER 2 1 STROKES"
                d="M19.75,40.78v8.11h4.19l3-8.11"
                style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
              />
              <path
                id="Layer0_27_MEMBER_0_MEMBER_2_1_STROKES-2"
                data-name="Layer0 27 MEMBER 0 MEMBER 2 1 STROKES"
                d="M36.09,40.78l3,8.11h4.19V40.78"
                style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
              />
            </g>
          </g>
        </svg>
      </div>
      <div
        className={`${descriptionClassName} ${styles.timelineRoomWrapperTitle}`}
      >
        {title && <div className={styles.timelineRoomTitle}>{title}</div>}
        {subtitle && (
          <div className={styles.timelineRoomSubTitle}>{subtitle}</div>
        )}
      </div>
    </div>
  );
};

Room.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  timelineIconClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  url: PropTypes.string,
};

export default Room;
